import clsx from "clsx"

export type DividerProps = {
  color?: "gray" | "white" | "current" | "green"
  className?: string
}

export const Divider = ({ color = "gray", className }: DividerProps) => (
  <div
    className={clsx("w-full border-b", className, {
      "border-gray-200": color === "gray",
      "border-white": color === "white",
      "border-current": color === "current",
      "border-np-green10": color === "green",
    })}
  />
)
